// The agent's sql is part of what the definition means, so it is
// stored with the body rather than left behind on the message.
// Dependency-free so the frontend can rebuild the body an
// assumption was cited with.
export function assumptionDefinitionMarkdown(assumption: {
  content: string;
  sql?: string | null;
}): string {
  const body = assumption.content.trim();
  const sql = assumption.sql?.trim();
  return sql ? `${body}\n\n\`\`\`sql\n${sql}\n\`\`\`` : body;
}
